import React, { createContext, useEffect, useState } from "react";
// import { dataClone } from "../services/dummy";

export const AttributesContext = createContext();

export const AttributesContextProvider = ({ children }) => {
	const [attributesData, setAttributesData] = useState();

	useEffect(() => {
		if (!attributesData) {
			window.setAttributesData = setAttributesData;
		}
		return () => {
			delete window.setAttributesData; // Clean up on unmount
		};
	}, [attributesData]);

	return <AttributesContext.Provider value={{ setAttributesData, attributesData }}>{children}</AttributesContext.Provider>;
};
